import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-fort-mart',
    templateUrl: './fort-mart.component.html',
    styleUrls: ['./fort-mart.component.scss'],
    standalone: false
})
export class FortMartComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
